import { render, staticRenderFns } from "./DateTimeFormattor.vue?vue&type=template&id=d59ea366"
import script from "./DateTimeFormattor.vue?vue&type=script&lang=js"
export * from "./DateTimeFormattor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports